import { VERSION } from '../services/EnvironmentService';

export const loadStateFromSessionStorage = () => {
	try {
		const serializedState = sessionStorage.getItem(getSessionKey());
		if (!serializedState) {
			return undefined; // No state in sessionStorage
		}

		return JSON.parse(serializedState);
	} catch (err) {
		console.error('Failed to load sessionStorage', err);
		return undefined; // Handle errors e.g. JSON parsing errors
	}
};

export const saveStateToSessionStorage = (state: any) => {
	try {
		const serializedState = JSON.stringify(removeStoreSlices(state));
		sessionStorage.setItem(getSessionKey(), serializedState);
		//TODO Clear browser history state to prevent going back to cleared state with back button after finishing,
		// as this can cause bugs if user goes back to a page with forms and then forward again to receipt page.
	} catch (err) {
		console.error('Failed to save sessionStorage', err);
	}
};

export const removeStateFromSessionStorage = () => {
	try {
		sessionStorage.removeItem(getSessionKey());
		sessionStorage.removeItem('reloaded');
	} catch (err) {
		console.error('Failed to remove sessionStorage', err);
	}
};

const excludeSlicesFromStorage = ['customer', 'customerProducts', 'modal'];

export const removeStoreSlices = (state) => {
	if (!state) {
		return state;
	}
	const stateCopy = { ...state };
	excludeSlicesFromStorage.forEach((key) => {
		stateCopy[key] = {};
	});
	return stateCopy;
};

const getSessionKey = (): string => {
	const insuranceId = location.pathname.split('/')?.filter(Boolean)?.pop();
	// insuranceId = indbo, rejse etc...
	return `redux-state-${insuranceId || ''}-${VERSION}`;
};
